/* globals Sortable, module, require, SimpleMDE, window, _, Materialize */

var buildDialog = require('./dialog-builder');
var fuzzysearch = require('./fuzzysearch');
var addChildHelpers = require('./add-child-helpers');
var pathWidget = require('./path-widget');
var editPageDialogs = require('./page-dialogs');
import { updateOrder, initializeOrder, orderMatchHeight } from './order-helpers';
import { Clipboard } from './stores/Clipboard';
import { autorun, action } from 'mobx';
import { getCsrfTokenPromise } from './csrf';

const componentClipboard = new Clipboard('component');

module.exports = function ($, window, page, editDialog) {
	'use strict';
	var pageInit = {};

	$.ajaxSetup({ cache: false });

	/***************************************************************************************************/
	pageInit['.button-collapse'] = function ($el) {
		$el.sideNav();
	};

	/***************************************************************************************************/
	pageInit['.bl-open-dialog-button'] = function ($el) {
		$el.modalButton(editDialog.getStandardEditDialogOptions());
	};

	/***************************************************************************************************/
	pageInit['body.home'] = function ($el) {
		if ($el.length) {
			var home = require('./home-client.js')($, window);
			home.init();
		}
	};

	/***************************************************************************************************/
	pageInit['body.landing'] = function ($el) {
		if ($el.length) {
			$('.landing-link').click(function () {
				var link = $(this).data('link');
				if (link.match(/^http/)) {
					window.open(link, '_blank');
				} else {
					window.document.location.href = link;
				}
			});
		}
	};

	/***************************************************************************************************/
	pageInit['body.generic-iframe'] = function ($el) {
		if ($el.length) {
			var iframed = require('./framed-client.js')($, window);
			iframed.init();
		}
	};

	/***************************************************************************************************/
	pageInit['body.bl-page.edit'] = function ($el) {
		var links = $('span.file-link');
		links.each(function () {
			var $el = $(this);
			var slingPath = page.getButtonSlingPath($el) + '/' + $el.data('name');
			var oldHtml = $el.html();
			$el.html(`<a href="${page.blProxyPrefix}${slingPath}" target="_blank">${oldHtml}</a>`);
		});

		$('.collapsible-header, .edit-button').hover(
			function () {
				var $header = $(this);
				if ($header.data('target')) {
					// oops, acutally an edit button, not a header.
					$header = $header.closest('.item-buttons').siblings('.collapsible-header');
				}

				var childCount = $header.data('childCount');
				var off = $header.offset();

				if (typeof childCount == 'undefined') {
					var $buttons = $header.closest('.inner-li').find('a.edit-button');
					childCount = $buttons.length;
					$header.data('childCount', childCount);
					var leftOff = childCount > 9 ? 36 : 28;
					if (off) {
						$header.append(
							`<div style="position:absolute; top:${off.top}px; left:${off.left - leftOff}px; display:none;" class="child-count">${childCount}<span class="child-count-arrow">↴</span></div>`
						);
					}
				}

				var $count = $header.find('.child-count');
				$count.css('display', 'block');
				if (off) {
					$count.css('top', `${off.top}px`);
				}
			},
			function () {
				var $header = $(this);
				if ($header.data('target')) {
					// oops, acutally an edit button, not a header.
					$header = $header.closest('.item-buttons').siblings('.collapsible-header');
				}
				$header.find('.child-count').css('display', 'none');
			}
		);
	};

	/***************************************************************************************************/
	pageInit['.bl-go-preview'] = function ($el) {
		$el.on('click', function () {
			var match = window.document.location.href.match(
				/^(https?:\/\/[^\/]*)\/[^#]*\/blacklight\/edit\/page(.*)$/
			);
			if (match) {
				window.location.href = match[1] + match[2];
			} else {
				page.setCookie('wcmmode', 'preview', 7);
				window.location.assign(document.location.pathname + document.location.hash);
				window.location.reload(true);
			}
		});
	};

	/***************************************************************************************************/
	pageInit['.bl-documentation'] = function ($el) {
		$el.on('click', function () {
			var match = window.document.location.href.match(
				/^(https?:\/\/[^\/]*)\/([^#]*\/blacklight\/edit\/page)?(.*)$/
			);
			if (match) {
				window.location.href =
					match[1] +
					'/alt/apps/blacklight/edit/documentation' +
					(_.startsWith(match[3], '/') ? '' : '/') +
					match[3];
			}
		});
	};

	/***************************************************************************************************/
	pageInit['.bl-go-page-manager'] = function ($el) {
		$el.on('click', function () {
			var match = window.document.location.href.match(
				/^(https?:\/\/[^\/]*)\/[^#]*\/blacklight\/edit\/page(.*)$/
			);
			if (match) {
				var path = match[2].match(/^(.*?)(\/|\.html)?(#.*)?$/);
				var pmPath = page.proxyMode
					? window.BL.config.appsMount + 'blacklight/edit/page-manager#!'
					: '/pm#!';
				var finalPath = match[1] + pmPath + path[1] + '.edit';
				window.location.href = finalPath;
			}
		});
	};

	/***************************************************************************************************/
	pageInit['.bl-coming-soon'] = function ($el) {
		$el.on('click', function () {
			window.alert('This feature is not working yet.  Coming soon.');
		});
	};

	/***************************************************************************************************/
	pageInit['.bl-history'] = function ($el) {
		$el.click(function () {
			editPageDialogs.history(page.baseUrl, page.blProxyPrefix, window.BL.config.appsMount);
		});
	};

	/***************************************************************************************************/
	pageInit['.bl-activation'] = function ($el) {
		$el.on('click', function () {
			var deactivate = $(this).data('deactivate');
			if (deactivate) {
				editPageDialogs.deactivate(page.baseUrl, page.blProxyPrefix, window.BL.config.appsMount);
			} else {
				editPageDialogs.activate(page.baseUrl, page.blProxyPrefix, window.BL.config.appsMount);
			}
		});
	};

	/***************************************************************************************************/
	pageInit['.item-menu'] = function ($el) {
		var menuIdCount = 0,
			allMenuButtons = [];
		$el.css('cursor', 'pointer');

		$el.click(function () {
			var $menuButton = $(this);
			debugger;
			const isParSys = $menuButton.data('is-ecc');
			const $holder = $menuButton.closest('[data-key]');

			var isEccEntry = $menuButton.hasClass('ecc-entry');
			var $pasteMenu;
			var rtype = isParSys ? 'foundation/components/parsys' : $holder.data('sling-type');
			var parentContext = page.getButtonSlingPath($menuButton, true);
			var context = {
				type: rtype,
				path: parentContext.path,
				parentContexts: parentContext,
				buildDialog,
				editDialog,
			};

			var menuId = 'bl-content-menu-' + menuIdCount++;
			var toolMenuId = 'bl-tool-menu-' + menuIdCount++;

			var submenuArrow = `<i class="material-icons tiny" style="font-size:.9rem;float:right;margin-right:5px;margin-top:14px;color:#999;">play_arrow</i>`;

			if (isEccEntry || isParSys) {
				var pasteEccHtml = `<ul id="paste_${menuIdCount}" class="dropdown-content menu-body">
					<li><a class="paste-item"  data-action="${isParSys ? 'prepend' : 'before'}" href="#"><i class="material-icons small">keyboard_arrow_up</i>${isParSys ? 'Prepend items' : 'Paste before current'}</a></li>
					${!isParSys ? '<li><a class="paste-item"  data-action="replace" href="#"><i class="material-icons small">play_for_work</i>Replace current</a></li>' : ''}
					<li><a class="paste-item" data-action="${isParSys ? 'append' : 'after'}" href="#"><i class="material-icons small">keyboard_arrow_down</i>${isParSys ? 'Append items' : 'Paste after current'}</a></li>
				</ul>`;

				$pasteMenu = $(pasteEccHtml);
				$('body').append($pasteMenu);
			}

			var toolHtml = `<ul id="${toolMenuId}" class="dropdown-content menu-body">
			</ul>`;

			var $toolMenu = $(toolHtml),
				hasMenu = false;

			_.each(['local', 'page'], mode => {
				var parts = rtype.split('/');
				var menuPath;
				if (mode === 'local') {
					menuPath = ['modules', parts[0], parts[1], 'bl', 'menus'].concat(parts.slice(2));
				} else {
					parts = window.BL.config.page.resourceType.split('/');
					menuPath = ['modules', parts[0], parts[1], 'bl', 'pageMenus'].concat(parts.slice(2));
				}

				var menus = _.get(window.BL, menuPath);

				if (_.isFunction(menus)) {
					menus = menus(context);
				}
				if (!_.isArray(menus)) {
					menus = [menus];
				}

				try {
					_.each(menus, function (menu, idx) {
						if (_.isFunction(menu)) {
							menu = menu(context);
						}
						if (menu && menu.title) {
							hasMenu = true;

							var $menuButton = $(
								`<li class="${menu.classes}${menu.disabled ? ' disabled' : ''}"><a href="#"><i class="material-icons small">${menu.icon || 'settings'}</i>${menu.title}</a></li>`
							);
							$menuButton.click(function (evt) {
								if (!menu.disabled) {
									if (!menu.action) {
										Materialize.toast('No menu action found.', 8000);
									} else {
										menu.action(_.defaults(context, { menu: menu, $menuButton: $menuButton }));
									}
								}
								evt.preventDefault();
							});
							$toolMenu.append($menuButton);
						}
					});
				} catch (err) {
					var msg = 'Internal error. Problem loading menu at: ' + rtype;
					window.alert(msg);
					console.log(msg);
					console.trace(err);
					return;
				}
			});

			var toolsMenuButton = '';
			if (hasMenu) {
				$('body').append($toolMenu);
				toolsMenuButton = `<li>${submenuArrow}<a class="tools-menu" href="#"><i class="material-icons small">build</i>Tools</a></li>`;
			}

			var html = `<ul id="${menuId}" class="dropdown-content menu-body">
				${toolsMenuButton}
				<li class="divider"></li>
				<li><a class="copy-item" href="#"><i class="material-icons small">content_copy</i>${isParSys ? 'Copy all children' : 'Copy'}</a></li>
				<li>${isEccEntry || isParSys ? submenuArrow : ''}<a class="paste-item" href="#"><i class="material-icons small">content_paste</i>Paste</a></li>
				<li class="divider"></li>
				${
					!isParSys
						? `
				<li><a class="add-annotation" href="#"><i class="material-icons small">chat_bubble_outline</i>Notes</a></li>
				<li><a class="show-documentation" href="#"><i class="material-icons small">library_books</i>Docs</a></li>`
						: ''
				}
				<li><a class="expand-all" href="#"><i class="material-icons small">unfold_more</i>Expand All</a></li>
				<li><a class="collapse-all" href="#"><i class="material-icons small">unfold_less</i>Collapse All</a></li>
			</ul>`;

			var $menu = $(html);

			$('body').append($menu);

			$menuButton.off('click');
			$menuButton.attr('data-activates', menuId);
			$menuButton.dropdown({
				inDuration: 300,
				outDuration: 225,
				constrainWidth: false, // Does not change width of dropdown to that of the activator
				hover: false, // Activate on hover
				gutter: 20, // Spacing from edge
				belowOrigin: true, // Displays dropdown below the button
				alignment: 'right', // Displays dropdown with edge aligned to the left of button
				stopPropagation: true, // Stops event propagation
			});

			$menuButton.dropdown('open');

			var subMenuOptions = {
				hover: true,
				alignment: 'left',
				belowOrigin: false,
				stopPropagation: true,
				constrainWidth: false,
				gutter: $menu.width() - 28,
			};

			$menu
				.find('.tools-menu')
				.parent()
				.attr('data-activates', toolMenuId)
				.dropdown(subMenuOptions);

			if (isEccEntry || isParSys) {
				$menu
					.find('.paste-item')
					.parent()
					.attr('data-activates', `paste_${menuIdCount}`)
					.dropdown(subMenuOptions);
			}

			$menu.find('.copy-item').click(
				action(e => {
					componentClipboard.update({
						path: context.path,
						resType: context.type,
						multi: isParSys,
					});
					e.preventDefault();
				})
			);

			$menu.find('.add-annotation').click(function (ev) {
				ev.preventDefault();
				buildDialog({
					noSave: true,
					title: 'Annotations',
					url: window.BL.config.appsMount + 'blacklight/edit/annotations.html?path=' + context.path,
				});
			});

			$menu.find('.show-documentation').click(function (ev) {
				ev.preventDefault();
				buildDialog({
					noSave: true,
					title: 'Component Documentation',
					url: window.BL.config.appsMount + 'blacklight/edit/documentation' + context.path,
					iframe: true,
				});
			});

			$menu.find('.expand-all').click(function (ev) {
				ev.preventDefault();
				const $body = isParSys
					? $(this).closest('.eccTitle').next('.eccContainer')
					: $(this).closest('ul').siblings('.collapsible-body');
				const collapsibles = $body.find('.collapsible');
				collapsibles.each((index, collapsible) => {
					$(collapsible).find('.collapsible-header').addClass('active');
					$(collapsible).collapsible({ accordion: false });
				});
			});

			$menu.find('.collapse-all').click(function (ev) {
				ev.preventDefault();
				const $body = isParSys
					? $(this).closest('.eccTitle').next('.eccContainer')
					: $(this).closest('ul').siblings('.collapsible-body');
				const collapsibles = $body.find('.collapsible');
				collapsibles.each((index, collapsible) => {
					$(collapsible).find('.collapsible-header').removeClass('active');
					$(collapsible).collapsible({ accordion: true });
				});
			});

			var $pasteButtons = (isEccEntry || isParSys ? $pasteMenu : $menu).find('.paste-item');

			const toggleDisabledOn = (jqObj, disable, tooltip) => {
				if (disable) {
					jqObj.parent('li').addClass('disabled');
					jqObj.addClass('disabled');
					if (tooltip) {
						jqObj.tooltip(tooltip);
					}
				} else {
					jqObj.parent('li').removeClass('disabled');
					jqObj.removeClass('disabled');
					jqObj.tooltip('remove');
				}
			};

			autorun(
				() => {
					if (componentClipboard.pastable) {
						const $replaceButton =
							isEccEntry || isParSys
								? $pasteButtons.filter("[data-action='replace']")
								: $pasteButtons;
						const $beforeAfterButtons = $pasteButtons
							.filter('[data-action]')
							.not("[data-action='replace']");

						if (componentClipboard.multi) {
							if (isEccEntry || !isParSys) {
								//can't 'replace current' if we're dealing with multiple unless we're a parsys
								toggleDisabledOn($replaceButton, true, {
									tooltip: `Can't paste multiple items into a single item.`,
								});
								toggleDisabledOn($beforeAfterButtons, false);
							} else if (isParSys && componentClipboard.path === context.path) {
								toggleDisabledOn($beforeAfterButtons, false);
							} else {
								toggleDisabledOn($pasteButtons, false);
							}
						} else if (!isParSys && componentClipboard.resType !== context.type) {
							toggleDisabledOn($replaceButton, true, {
								tooltip: `Type conflict. Can't paste '${componentClipboard.resType}' into '${context.type}'`,
							});
							toggleDisabledOn($beforeAfterButtons, false);
						} else if (componentClipboard.path === context.path) {
							toggleDisabledOn($replaceButton, true, {
								tooltip: `This item is in the clipboard, can't replace itself.`,
							});
							toggleDisabledOn($beforeAfterButtons, false);
						} else {
							toggleDisabledOn($pasteButtons, false);
						}
					} else {
						toggleDisabledOn($pasteButtons, true, { tooltip: 'Nothing in the clipboard' });
					}
				},
				{ fireImmediately: true }
			);

			$pasteButtons.click(async function (ev) {
				ev.preventDefault();
				const $btn = $(this);
				const disabled = $btn.hasClass('disabled');

				if (!disabled) {
					const sourcePath = componentClipboard.path;
					const sourceType = componentClipboard.resType;
					const multi = componentClipboard.multi;
					const action = $btn.data('action') || (isParSys ? 'inside' : 'replace');

					const url = `${window.BL.config.appsMount}blacklight/edit/paste/component`;

					const params = {
						sourcePath,
						action,
						multi,
						targetPath: context.path,
					};
					const postBody = new URLSearchParams();
					Object.keys(params).forEach(key => {
						postBody.append(key, params[key]);
					});

					try {
						const { token } = await getCsrfTokenPromise();
						const pasteResult = await fetch(url, {
							method: 'POST',
							headers: {
								'CSRF-Token': token,
							},
							body: postBody,
						}).then(res => res.json());

						if (pasteResult.status === 'success') {
							//reload the page to see the pasted result
							window.location.reload(true);
						} else {
							console.error('Paste action failed', {
								pasteResult,
								params: { action, sourcePath, targetPath: context.path, multi },
							});
							Materialize.toast(`Paste failed. Error: ${pasteResult.message}`, 6000);
						}
					} catch (e) {
						console.error('Paste action failed with an unexpected error', {
							params: { action, sourcePath, targetPath: context.path, multi },
						});
						Materialize.toast(
							'Paste failed. An Unexpected error occurred. See the console for more details.',
							6000
						);
					}
				}
			});

			function closeAllOthers() {
				/// Handles a minor bug in materialize dropdown.  Force close of other dropdowns, to be safe.
				$.each(allMenuButtons, function (idx, $btn) {
					if (!$menuButton.is($btn)) {
						$btn.dropdown('close');
					}
				});
				// TODO: check if "paste" is currently available and enable/disable menu button accordingly
			}

			closeAllOthers();
			allMenuButtons.push($menuButton);
			$menuButton.click(closeAllOthers);
		});
	};

	/***************************************************************************************************/
	pageInit['.bl-add-to-ecc'] = function ($el) {
		// Setup of "add child component buttons" (i.e. ghostly green "plus" buttons)
		$el.click(addChildHelpers.onEccAdd(page, editDialog));
	};

	/***************************************************************************************************/
	pageInit['div.markdown-text'] = function ($items) {
		$items.each(function () {
			var $el = $(this);
			var contents = $el.data('contents');
			// TODO: Might want a more general-purpose way of fixing these backlash-escaped chars
			if (contents) {
				contents = contents.replace(/\\r/g, '').replace(/\\n/g, '\n').replace(/\\t/g, '\t');
				if (SimpleMDE) {
					$el.html(SimpleMDE.prototype.markdown(contents));
				}
			}
		});
	};

	/***************************************************************************************************/
	pageInit['.delete-composite'] = function ($el) {
		$el.click(function (event) {
			var x = $(this).parent('li');
			x.remove();
		});
	};

	/***************************************************************************************************/
	pageInit['ul.collapsible'] = function ($el) {
		if ($el.find('i.drag-handle').length < 1) {
			return;
		}

		//////////////////////////////////////////////////////////
		$el.each(function () {
			var $collection = $(this);
			if (typeof Sortable === 'undefined') {
				console.error("Please load the 'Sortable' Javascript library");
				return;
			}

			// make sure the item order lines up
			$collection.on('click', () => {
				orderMatchHeight($collection);
			});
			Sortable.create(this, {
				handle: '.drag-handle',
				animation: 150,
				// Element dragging started
				onStart: function (/**Event*/ evt) {
					var $moving = $(evt.item);
					initializeOrder($moving);
					evt.oldIndex; // element index within parent
				},
				onEnd: function (/**Event*/ evt) {
					var $moved = $(evt.item);
					var idx = evt.newIndex;
					var orderOrder;

					var slingPath = page.getButtonSlingPath($moved.find(':first'));

					if (idx > 0) {
						var $prev = $moved.prev();
						var prevKey = $prev.data('key');
						orderOrder = 'after ' + prevKey;
					} else {
						orderOrder = 'first';
					}

					var fd = new window.FormData();
					fd.append('_charset_', 'utf-8');
					fd.append(':order', orderOrder);

					var request = new window.XMLHttpRequest();
					request.open('POST', page.blProxyPrefix + slingPath);
					request.send(fd);
					request.onload = function (event) {
						if (request.status === 200) {
							/// TODO: show toaster popup here saying "All is groovy"
							var x = 'OKEY DOKEY';
						} else {
							window.alert('ERROR: Problem reordering item.');
						}
					};

					updateOrder($moved);
				},
			});
		});
	};

	/***************************************************************************************************/
	pageInit['ul.tabs'] = function ($el) {
		$el.tabs();
	};

	/***************************************************************************************************/
	pageInit['table.panel-content'] = function ($el) {
		$el.each(function (idx, el) {
			if (!el.children[0] || !el.children[0].children.length) {
				$(el).parent().css('display', 'none');
			}
		});
	};

	/***************************************************************************************************/
	pageInit['.delete-contained-item'] = function ($el) {
		$el.click(function () {
			var $btn = $(this);
			var slingPath = page.getButtonSlingPath($btn);
			var $dialog = $('#bl-delete-dialog');
			var $deleteButton = $dialog.find('.bl-delete-button');
			var $modalContent = $dialog.find('.modal-content');

			$deleteButton.off().click(function () {
				var uri;
				uri = page.blProxyPrefix + slingPath;

				var fd = new window.FormData();
				fd.append('_charset_', 'utf-8');
				fd.append(':operation', 'delete');

				var request = new window.XMLHttpRequest();
				request.open('POST', uri);
				request.send(fd);
				request.onload = function (event) {
					if (request.status === 200) {
						var $li = $btn.closest('li'),
							$addBtn = $li.closest('ul').siblings('.bl-add-to-ecc');

						var $itemsOrder = $li.parents('.eccContainer').siblings('.items-order');
						if ($itemsOrder.length) {
							const $children = $itemsOrder.children('li');
							$($children[$li.index()]).remove();
						}

						var maxItems = $addBtn.data('max-items');
						var remainingItems = $li.siblings().length;

						if (remainingItems) {
							const $sibling = $li.siblings().first();
							$li.remove();
							initializeOrder($sibling, true);
							updateOrder($sibling, false);
						} else {
							$li.html(
								'<div style="padding:8px; color:#999; padding-left:16px; padding-top:12px;">Currently empty.  Click the plus buton to add an item.</div>'
							);
						}

						if (remainingItems < maxItems) {
							$addBtn.toggle(true);
						}

						$dialog.closeModal();
					} else {
						$modalContent.html(
							"<span class='red-text'>Error deleting content at '" + slingPath + "' </span>"
						);
					}
				};
			});

			$dialog.css({ height: '75%', width: '70%', maxWidth: '700px' });

			var title = $btn.closest('li').find('.item-title').first().html();
			$modalContent.html(
				"Are you sure you wish to delete this entry?<div class='card' style='margin:30px; width: calc(100% - 110px); padding:24px;'>" +
					title +
					'</div>'
			);
			$dialog.openModal({ top: '14%' });
		});
	};

	/***************************************************************************************************/
	pageInit['select.materialize'] = function ($el) {
		$el.material_select();
	};

	/***************************************************************************************************/
	pageInit['input[type="text"].path-widget'] = function ($el) {
		$el.each(function () {
			// retrieve element attributes
			pathWidget($(this));
		});
	};

	/***************************************************************************************************/
	pageInit['.processing-query'] = function ($el) {
		$el.each(function () {
			var thisProcessor = $(this);

			var localKey = thisProcessor.data('component-key')
				? '/' + thisProcessor.data('component-key')
				: '';
			var blQPath = page.blProxyPrefix + page.getButtonSlingPath(thisProcessor) + localKey;

			var checkProcessing = function () {
				$.get(blQPath + '.bl-processing.json', function (data) {
					if (!data || data['processing']) {
						//recheck in another second
						setTimeout(checkProcessing, 1000);
					} else {
						//update UI
						thisProcessor.find('.loading').hide();
						thisProcessor.find('.done').show();
					}
				});
			};

			setTimeout(checkProcessing, 1000);
		});
	};

	return pageInit;
};
